import { render } from "./PredictionBoosterMetricsPanel.vue?vue&type=template&id=8ecbe39c&scoped=true"
import script from "./PredictionBoosterMetricsPanel.vue?vue&type=script&lang=js"
export * from "./PredictionBoosterMetricsPanel.vue?vue&type=script&lang=js"

import "./PredictionBoosterMetricsPanel.vue?vue&type=style&index=0&id=8ecbe39c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ecbe39c"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QCard});
